export default __webpack_public_path__ + "static/media/bus-side-view-white.21ebfffa.svg";